import { Link as RouterLink, useNavigate } from 'react-router-dom'
import { trackCTAClick } from '../services/analytics'
import { keyframes } from '@emotion/react'
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  VStack,
  HStack,
  Image,
} from '@chakra-ui/react'

const wiggle = keyframes`
  0%, 100% { transform: rotate(-3deg); }
  50% { transform: rotate(3deg); }
`

const CallToAction = () => {
  const navigate = useNavigate()

  return (
    <Box bg="white" py={{ base: 16, md: 24 }} data-landing="cta">
      <Container maxW="6xl">
        <Box
          bg="purple.600"
          rounded="3xl"
          p={{ base: 8, md: 12, lg: 16 }}
          position="relative"
          overflow="hidden"
        >
          <Box
            position="absolute"
            top="-50px"
            right="-50px"
            w="200px"
            h="200px"
            bg="purple.500"
            rounded="full"
            opacity={0.3}
          />
          <Box
            position="absolute"
            bottom="-30px"
            left="-30px"
            w="150px"
            h="150px"
            bg="gold.400"
            rounded="full"
            opacity={0.2}
          />

          <HStack
            gap={{ base: 8, lg: 12 }}
            align="center"
            flexDirection={{ base: 'column', lg: 'row' }}
            position="relative"
            zIndex={1}
          >
            <Box flex={{ lg: 1 }}>
              <Image
                src="/capirote-amarillo.png"
                alt=""
                maxW={{ base: '200px', md: '250px' }}
                mx="auto"
                css={{ animation: `${wiggle} 2s ease-in-out infinite` }}
              />
            </Box>

            <VStack
              flex={{ lg: 2 }}
              gap={6}
              align={{ base: 'center', lg: 'flex-start' }}
              textAlign={{ base: 'center', lg: 'left' }}
            >
              <Heading
                as="h2"
                fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
                fontWeight="800"
                color="white"
                lineHeight="1.1"
              >
                ¿Listo para empezar?
              </Heading>
              <Text fontSize={{ base: 'lg', md: 'xl' }} color="purple.100" maxW="2xl">
                Crea la cuenta de tu banda y monta plantilla, archivo y web pública.
                Si representas a una hermandad, te explicamos cómo encontrar agrupaciones.
              </Text>
              <HStack
                gap={4}
                pt={2}
                w={{ base: 'full', sm: 'auto' }}
                flexDirection={{ base: 'column', sm: 'row' }}
                flexWrap="wrap"
              >
                <Button
                  size="lg"
                  px={8}
                  py={7}
                  fontSize="lg"
                  fontWeight="bold"
                  bg="white"
                  color="purple.600"
                  rounded="full"
                  _hover={{ bg: 'gray.100' }}
                  onClick={() => {
                    trackCTAClick('crear_cuenta', 'call_to_action')
                    navigate('/registro?tipo=banda')
                  }}
                  w={{ base: 'full', sm: 'auto' }}
                >
                  Crear cuenta de banda
                </Button>
                <Button
                  size="lg"
                  px={8}
                  py={7}
                  fontSize="lg"
                  fontWeight="bold"
                  bg="transparent"
                  color="white"
                  border="2px solid"
                  borderColor="white"
                  rounded="full"
                  _hover={{ bg: 'whiteAlpha.200' }}
                  onClick={() => {
                    trackCTAClick('iniciar_sesion', 'call_to_action')
                    navigate('/login')
                  }}
                  w={{ base: 'full', sm: 'auto' }}
                >
                  Iniciar sesión
                </Button>
              </HStack>
              <Button variant="plain" color="white" fontWeight="700" asChild>
                <RouterLink
                  to="/hermandades"
                  onClick={() => trackCTAClick('hermandades', 'call_to_action')}
                >
                  Soy una hermandad
                </RouterLink>
              </Button>
            </VStack>
          </HStack>
        </Box>
      </Container>
    </Box>
  )
}

export default CallToAction
